<template>
  <div class="page">
    <HeaderTop :is_login="false"></HeaderTop>
    <div class="pageContent d-flex d-flex-middle d-flex-center">
      <div class="bmContent">
        <div class="progressBox">
          <BmProgress :steps="steps" :current-step="0" />
        </div>
        <div class="contentBox">
          <Notice @next-step="handleNext" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import BmProgress from "@/components/bm/bmProgress.vue";
import Notice from "@/components/bm/notice.vue";

export default {
  name: 'Step0Notice',
  components: {
    HeaderTop,
    Footer,
    BmProgress,
    Notice
  },
  data() {
    return {
      steps: [
        { title: '阅读报名须知' },
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
        { title: '缴费' }
      ]
    }
  },
  methods: {
    handleNext() {
      this.$router.push({ name: 'BmStepSelectLocation' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  position: relative;
}

.pageContent {
  padding: 20px;
  min-height: calc(100vh - 200px);
  margin-top: 70px;
  background: url('../../assets/bm/bmBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.bmContent {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.progressBox {
  width: 100%;
  margin-bottom: 20px;
}

.contentBox {
  width: 1000px;
  margin: 0 auto;
  border-top: 1px solid #E9EFF9;
}
</style>
